import * as React from 'react';

import { OprSession } from '~/shared/auth/types/session';
import { UserFactory } from '~/shared/auth/user-factory';

type UserContextProps =
  | ReturnType<typeof UserFactory.createUserFromSession>
  | undefined;
export const UserContext = React.createContext<UserContextProps | undefined>(
  undefined
);

type UserProviderProps = {
  session?: OprSession;
  children: React.ReactNode;
};

export function UserProvider({ session, children }: UserProviderProps) {
  const user = UserFactory.createUserFromSession(session?.user);
  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
}

export function useUser() {
  const context = React.useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }

  return context;
}

export type User = ReturnType<typeof useUser>;
